var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Whatsapp from "./Whatsapp";
import SliderYoutubeBackground from "./SliderYoutubeBackground";
var SlideHomeBlur = /** @class */ (function (_super) {
    __extends(SlideHomeBlur, _super);
    function SlideHomeBlur() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentSlide = 0;
        _this.currentSlideDelay = 0;
        _this.mouseover = false;
        _this.timeSlide = 5000;
        _this.lastTime = 0;
        _this.currentTime = 0;
        _this.slidesCurrent = {};
        _this.slide1 = null;
        _this.slide2 = null;
        _this.slide3 = null;
        _this.imagesLoaded = [];
        return _this;
    }
    SlideHomeBlur.prototype.beforeMount = function () {
        var _this = this;
        this.slide(this.currentSlide);
        this.lastTime = Date.now();
        Promise.all(this.slides.map(function (slide) { return _this.getImage(slide.background); })).then(function () {
            if (_this.slides.length > 1) {
                setInterval(function () {
                    if (!_this.mouseover) {
                        _this.currentTime += Date.now() - _this.lastTime;
                    }
                    _this.lastTime = Date.now();
                    if (_this.currentTime > _this.timeSlide) {
                        _this.currentTime = 0;
                        _this.slide(_this.currentSlide + 1);
                    }
                }, 100);
            }
        });
    };
    SlideHomeBlur.prototype.getImage = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var img = new Image();
                        img.onload = function () {
                            _this.imagesLoaded.push(url);
                            resolve();
                        };
                        img.src = url;
                    })];
            });
        });
    };
    SlideHomeBlur.prototype.openUrl = function (index) {
        location.href = this.slidesCurrent[index].url;
    };
    SlideHomeBlur.prototype.slide = function (slideNumber) {
        var _this = this;
        var slide = this.getCorrectSlideNumber(slideNumber);
        this.currentSlide = slideNumber;
        setTimeout(function () {
            _this.currentSlideDelay = slideNumber;
        }, 100);
        this.slidesCurrent = {};
        this.slidesCurrent[this.currentSlide - 1] = this.slides[this.getCorrectSlideNumber(slide - 1)];
        this.slidesCurrent[this.currentSlide] = this.slides[slide];
        this.slidesCurrent[this.currentSlide + 1] = this.slides[this.getCorrectSlideNumber(slide + 1)];
    };
    SlideHomeBlur.prototype.slideStyle = function () {
        return {
            transform: "translateX(" + String((this.currentSlide) * 100 * -1) + "%)"
        };
    };
    SlideHomeBlur.prototype.fontSizeStyle = function (index, size) {
        var _a;
        return {
            fontSize: ((_a = this.slidesCurrent[index]['font' + size]) !== null && _a !== void 0 ? _a : 100) + "%",
        };
    };
    SlideHomeBlur.prototype.lineHeightStyle = function (index, size) {
        var _a;
        return {
            lineHeight: "" + ((_a = this.slidesCurrent[index]['font' + size]) !== null && _a !== void 0 ? _a : 100) / 100,
        };
    };
    SlideHomeBlur.prototype.onMouseover = function () {
        this.mouseover = true;
    };
    SlideHomeBlur.prototype.onMouseleave = function () {
        this.mouseover = false;
    };
    SlideHomeBlur.prototype.getBackground = function (index) {
        var _this = this;
        if (!this.imagesLoaded.find(function (image) { return image === _this.slidesCurrent[index].background; })) {
            return {};
        }
        return {
            backgroundImage: "url(" + this.slidesCurrent[index].background + ")"
        };
    };
    SlideHomeBlur.prototype.getImageExist = function (index) {
        var _this = this;
        return !!this.imagesLoaded.find(function (image) { return image === _this.slidesCurrent[index].background; });
    };
    SlideHomeBlur.prototype.slideUnitStyle = function (index) {
        return {
            left: String((Number(index)) * 100) + "%"
        };
    };
    SlideHomeBlur.prototype.getCorrectSlideNumber = function (slideNumber) {
        slideNumber = slideNumber % this.slides.length;
        if (slideNumber < 0) {
            slideNumber = this.slides.length + slideNumber;
        }
        return slideNumber;
    };
    SlideHomeBlur.prototype.prevSlide = function () {
        if (this.slides.length > 1) {
            this.currentTime = 0;
            this.slide(this.currentSlide - 1);
        }
    };
    SlideHomeBlur.prototype.nextSlide = function () {
        if (this.slides.length > 1) {
            this.currentTime = 0;
            this.slide(this.currentSlide + 1);
        }
    };
    __decorate([
        Prop()
    ], SlideHomeBlur.prototype, "slides", void 0);
    SlideHomeBlur = __decorate([
        Component({
            components: {
                Whatsapp: Whatsapp,
                SliderYoutubeBackground: SliderYoutubeBackground
            },
        })
    ], SlideHomeBlur);
    return SlideHomeBlur;
}(Vue));
export default SlideHomeBlur;
